/**
 * Utilitaires pour la redirection WhatsApp
 */

const WHATSAPP_PHONE_NUMBER = "+33743715404"; // +33 7 43 71 54 04

/**
 * Ouvre une conversation WhatsApp avec le numéro spécifié
 * @param message - Message optionnel à pré-remplir
 */
export function openWhatsApp(message?: string) {
  const phoneNumber = WHATSAPP_PHONE_NUMBER.replace(/\s/g, ""); // Supprime les espaces
  const encodedMessage = message ? encodeURIComponent(message) : "";

  const whatsappUrl = `https://wa.me/${phoneNumber}${encodedMessage ? `?text=${encodedMessage}` : ""}`;

  // Ouvre dans un nouvel onglet
  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
}

/**
 * Ouvre WhatsApp avec un message de contact par défaut
 *
 * Appelée depuis un gestionnaire de clic (après le setup) : `useI18n()`
 * jetterait ici (il faut un composant en cours de montage) — on passe donc
 * par `useNuxtApp().$i18n.t()`, utilisable à tout moment (cf.
 * docs/architecture/i18n.md, « ailleurs » / TypeScript hors composant).
 */
export function openWhatsAppContact() {
  const defaultMessage = useNuxtApp().$i18n.t(
    "partage.whatsapp.messageContactParDefaut",
  );
  openWhatsApp(defaultMessage);
}
